import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Grid,
  Divider,
  Button,
  Typography,
  Box,
  Chip
} from '@mui/material';
import {
  Close as CloseIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  Home as HomeIcon,
  Bathtub as BathtubIcon,
  Bed as BedIcon,
  SquareFoot as SquareFootIcon,
  CalendarToday as CalendarIcon,
  Construction as ConstructionIcon,
  Download as DownloadIcon
} from '@mui/icons-material';
import palette from 'src/theme/palette';
import VToolReplyModal from './VToolReplyModal';
import { Reply } from '@mui/icons-material';
import useMediaQuery from '@mui/material/useMediaQuery';

const VToolViewModal = ({ open, onClose, valuation, onReplyClick }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  if (!valuation) return null;

  const getConditionColor = (condition) => {
    switch (condition) {
      case 'good':
        return 'success';
      case 'fair':
        return 'warning';
      case 'poor':
        return 'error';
      default:
        return 'default';
    }
  };

  // const handleDownloadReport = () => {
  //   if (!valuation) return;

  //   import('jspdf')
  //     .then(({ jsPDF }) => {
  //       const doc = new jsPDF();
  //       const pageWidth = doc.internal.pageSize.getWidth();
  //       const margin = 20;
  //       let yPos = margin;

  //       // Title
  //       doc.setFontSize(20);
  //       doc.setTextColor(51, 51, 51);
  //       doc.text('PROPERTY VALUATION REPORT', pageWidth / 2, yPos, { align: 'center' });
  //       yPos += 15;

  //       // Report ID and Date
  //       doc.setFontSize(10);
  //       doc.setTextColor(100, 100, 100);
  //       doc.text(`Report ID: ${valuation.id}`, margin, yPos);
  //       doc.text(`Generated: ${new Date().toLocaleDateString()}`, pageWidth - margin, yPos, {
  //         align: 'right'
  //       });
  //       yPos += 15;

  //       // Personal Information Section
  //       doc.setFontSize(14);
  //       doc.setTextColor(51, 51, 51);
  //       doc.text('1. PERSONAL INFORMATION', margin, yPos);
  //       yPos += 10;

  //       doc.setFontSize(11);
  //       doc.text(`Full Name: ${valuation.name}`, margin, yPos);
  //       yPos += 7;
  //       doc.text(`Email: ${valuation.email}`, margin, yPos);
  //       yPos += 7;
  //       doc.text(`Phone: ${valuation.phone}`, margin, yPos);
  //       yPos += 7;
  //       doc.text(`Address: ${valuation.address || 'N/A'}`, margin, yPos);
  //       yPos += 15;

  //       // Property Details Section
  //       doc.setFontSize(14);
  //       doc.text('2. PROPERTY DETAILS', margin, yPos);
  //       yPos += 10;

  //       doc.setFontSize(11);
  //       doc.text(
  //         `Property Type: ${
  //           valuation?.property_type?.name || valuation?.original_property_type?.name || 'N/A'
  //         }`,
  //         margin,
  //         yPos
  //       );
  //       yPos += 7;
  //       doc.text(`Condition: ${valuation.condition?.toUpperCase() || 'N/A'}`, margin, yPos);
  //       yPos += 7;
  //       doc.text(`Bedrooms: ${valuation.bed_rooms || 'N/A'}`, margin, yPos);
  //       yPos += 7;
  //       doc.text(`Bathrooms: ${valuation.bath_rooms || 'N/A'}`, margin, yPos);
  //       yPos += 7;
  //       doc.text(
  //         `Area Size: ${valuation.area_size || 'N/A'} ${
  //           valuation?.area_unit_type?.name || valuation?.original_area_unit_type?.name || ''
  //         }`,
  //         margin,
  //         yPos
  //       );
  //       yPos += 7;
  //       doc.text(`Build Year: ${valuation.build_year || 'N/A'}`, margin, yPos);
  //       yPos += 7;
  //       doc.text(
  //         `Location: ${valuation.state?.name || valuation.state_name || 'N/A'}, ${
  //           valuation.city?.name || valuation.city_name || 'N/A'
  //         }`,
  //         margin,
  //         yPos
  //       );
  //       yPos += 15;

  //       // Additional Information
  //       if (valuation.renovation_text) {
  //         doc.setFontSize(14);
  //         doc.text('3. RENOVATION NOTES', margin, yPos);
  //         yPos += 10;
  //         doc.setFontSize(11);

  //         // Split long text into multiple lines
  //         const maxWidth = pageWidth - margin * 2;
  //         const lines = doc.splitTextToSize(valuation.renovation_text, maxWidth);
  //         doc.text(lines, margin, yPos);
  //         yPos += lines.length * 7;
  //       }

  //       // Timestamps
  //       yPos += 10;
  //       doc.setFontSize(10);
  //       doc.setTextColor(100, 100, 100);
  //       doc.text(`Submitted: ${new Date(valuation.created_at).toLocaleString()}`, margin, yPos);
  //       yPos += 5;
  //       doc.text(`Last Updated: ${new Date(valuation.updated_at).toLocaleString()}`, margin, yPos);

  //       // Footer
  //       const footerY = doc.internal.pageSize.getHeight() - 20;
  //       doc.setFontSize(9);
  //       doc.text('© Estate Management System - Confidential Report', pageWidth / 2, footerY, {
  //         align: 'center'
  //       });

  //       // Save the PDF
  //       doc.save(
  //         `Property_Valuation_Report_${valuation.id}_${valuation.name.replace(/\s+/g, '_')}.pdf`
  //       );

  //       // Optional: Show success message
  //       console.log(`PDF report downloaded for ${valuation.name}`);
  //     })
  //     .catch((error) => {
  //       console.error('Error generating PDF:', error);
  //       // Fallback: Open print dialog for the modal content
  //       window.print();
  //     });
  // };

  // const getStatusText = (status) => {
  //   switch (status) {
  //     case '1':
  //       return 'Active';
  //     case '2':
  //       return 'Pending';
  //     default:
  //       return 'Unknown';
  //   }
  // };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          margin: { xs: 2, sm: 3 },
          maxHeight: isMobile ? '100vh' : '90vh',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          width: isMobile ? '100vw' : '1400px',
          margin: isMobile ? 0 : undefined
        }
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          background: `linear-gradient(135deg, ${palette.primary.main} 0%, ${palette.primary.dark} 100%)`,
          color: palette.primary.contrastText,
          py: 2,
          px: 3,
          mb: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography
          sx={{
            fontSize: 20,
            fontFamily: 'poppinsSemiBold',
            color: palette.primary.contrastText
          }}
        >
          Valuation Tool Details
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: palette.primary.contrastText,
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.1)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {/* Status Information  */}
          {/* <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1
                }}
              >
                Status
              </Typography>
              <Chip
                label={getStatusText(valuation.status)}
                color={valuation.status === '1' ? 'success' : 'warning'}
                size="small"
                sx={{ fontFamily: 'poppinsMedium' }}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
          </Grid> */}

          {/* Personal Information Section */}
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{
                color: palette.primary.main,
                fontFamily: 'poppinsSemiBold',
                mb: 2
              }}
            >
              Personal Information
            </Typography>
          </Grid>

          {/* Name */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                Full Name
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.name}
              </Typography>
            </Box>
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <EmailIcon fontSize="small" /> Email Address
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.email}
              </Typography>
            </Box>
          </Grid>

          {/* Phone */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <PhoneIcon fontSize="small" /> Phone Number
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.phone}
              </Typography>
            </Box>
          </Grid>

          {/* Address */}
          <Grid item xs={12}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <LocationIcon fontSize="small" /> Full Address
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.address || 'N/A'}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
          </Grid>

          {/* Property Details Section */}
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{
                color: palette.primary.main,
                fontFamily: 'poppinsSemiBold',
                mb: 2
              }}
            >
              Property Details
            </Typography>
          </Grid>

          {/* Property Type */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <HomeIcon fontSize="small" /> Property Type
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {/* Type {valuation.property_type_id} */}
                {/* {console.log(valuation?.original_property_type?.name)} */}
                {valuation?.original_property_type?.name}
              </Typography>
            </Box>
          </Grid>

          {/* Condition */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <ConstructionIcon fontSize="small" /> Condition
              </Typography>
              <Chip
                label={valuation.condition?.toUpperCase()}
                color={getConditionColor(valuation.condition)}
                size="small"
                sx={{ fontFamily: 'poppinsMedium' }}
              />
            </Box>
          </Grid>

          {/* Bedrooms and Bathrooms */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <BedIcon fontSize="small" /> Bedrooms
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.bed_rooms}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <BathtubIcon fontSize="small" /> Bathrooms
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.bath_rooms}
              </Typography>
            </Box>
          </Grid>

          {/* Square Feet */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <SquareFootIcon fontSize="small" /> Area Unit
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {console.log(valuation?.original_area_unit_type?.name)}
                {valuation?.original_area_unit_type?.name || '-'}
              </Typography>
            </Box>
          </Grid>

          {/* Area Size */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1
                }}
              >
                Area Size
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.area_size} {valuation?.original_area_unit_type?.name || ''}
              </Typography>
            </Box>
          </Grid>

          {/* Build Year */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}
              >
                <CalendarIcon fontSize="small" /> Build Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.build_year}
              </Typography>
            </Box>
          </Grid>

          {/* Location */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1
                }}
              >
                State & City
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular',
                  fontSize: '16px'
                }}
              >
                {valuation.city_name && valuation.state_name
                  ? `${valuation.city_name}, ${valuation.state_name}`
                  : valuation.city_name
                  ? valuation.city_name
                  : valuation.state_name
                  ? valuation.state_name
                  : 'N/A'}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
          </Grid>

          {/* Dates */}
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1
                }}
              >
                Created Date
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular'
                }}
              >
                {formatDate(valuation.created_at)}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="subtitle2"
                sx={{
                  color: palette.text.secondary,
                  fontFamily: 'poppinsMedium',
                  mb: 1
                }}
              >
                Last Updated
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: palette.text.primary,
                  fontFamily: 'poppinsRegular'
                }}
              >
                {formatDate(valuation.updated_at)}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          p: 3,
          alignItems: { xs: 'stretch', sm: 'center' }
        }}
      >
        {/* <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={handleDownloadReport}
          sx={{
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
            minWidth: 120,
            fontFamily: 'poppinsMedium',
            '&:hover': {
              backgroundColor: palette.primary.dark
            }
          }}
        >
          Download Report
        </Button> */}

        <Button
          variant="contained"
          startIcon={<Reply />}
          onClick={() => {
            if (onReplyClick) {
              onReplyClick(valuation);
            }
          }}
          sx={{
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
            minWidth: 120,
            fontFamily: 'poppinsMedium',
            width: { xs: '100%', sm: 'auto' },
            '&:hover': {
              backgroundColor: palette.primary.dark
            }
          }}
        >
          Submit Report
        </Button>

        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
            minWidth: 100,
            fontFamily: 'poppinsMedium',
            width: { xs: '100%', sm: 'auto' },
            '&:hover': {
              backgroundColor: palette.primary.dark
            }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VToolViewModal;
